import React, {useState, useEffect, useRef} from 'react';
//components
import View from './events-view';
//utils
import {OrganisationService} from '../../../utils/data-transfer';
//library utils
import _ from 'lodash';

const _organisationService = new OrganisationService();
const organisationId = process.env.REACT_APP_COMPETITIONGOLF_ORGANISATION_ID;

const EventsContainer = () => {
  const [state, setState] = useState({
    isLoading: true,
    filterText: '',
    events: [],
    eventsGrouped: [],
  });

  useEffect(() => {
    const bootstrapComponent = async () => {
      await getEvents();
      await setState((prevState => ({...prevState, isLoading: false})));
    };

    bootstrapComponent();
  }, []);

  const getEvents = async (filterText) => {
    try {
      let response = await _organisationService.getUpcomingEvents(filterText)
      response = response.filter(e => e.showOnPortal);

      let organisations = _.uniq(response.map(r => r.organisationId))
      let eventsGrouped = [];

      if (_.find(organisations, o => o.toLowerCase() !== organisationId.toLowerCase())) {
        organisations.forEach(o => {
          const e = _.find(response, r => r.organisationId === o);

          eventsGrouped.push({
            organisationId: o,
            name: e.organisation,
            events: response.filter(r => r.organisationId === o)
          });
        });

        setState((prevState => ({...prevState, events: [], eventsGrouped})));
        return;
      }

      setState((prevState => ({...prevState, events: response, eventsGrouped: []})));
    } catch (ex) {
      console.log(ex);
    }
  };

  const debounceGetEvents = useRef(_.debounce(getEvents, 1000));

  const handleSearchChange = (e) => {
    const filterText = e.target.value;
    setState(prevState => ({...prevState, filterText}));
    return debounceGetEvents.current(filterText);
  };

  return (
    <View
      {...state}
      handleSearchChange={handleSearchChange}/>
  );
}

export default EventsContainer;
